export class PreChatFormView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._isSubmitting = false;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'messenger-view messenger-prechat-view';

		this._updateContent();

		return this.element;
	}

	_updateContent() {
		const existingName = this.state.userContext?.name || '';
		const existingEmail = this.state.userContext?.email || '';

		this.element.innerHTML = `
			<div class="messenger-prechat-overlay">
				<div class="messenger-prechat-card">
					<h4 class="messenger-prechat-title">Get notified when we reply</h4>
					<form class="sdk-form-group" novalidate>
						<div class="sdk-form-group">
							<input
								type="text"
								id="messenger-prechat-name"
								name="name"
								placeholder="Name (optional)"
								value="${this._escapeHtml(existingName)}"
								autocomplete="name"
								class="sdk-input"
							/>
						</div>
						<div class="sdk-form-group">
							<input
								type="email"
								id="messenger-prechat-email"
								name="email"
								placeholder="Email address"
								value="${this._escapeHtml(existingEmail)}"
								required
								autocomplete="email"
								class="sdk-input"
							/>
							<span class="messenger-prechat-error" id="messenger-email-error"></span>
						</div>
						<div class="messenger-prechat-actions">
							<button type="button" class="sdk-btn sdk-btn-secondary messenger-prechat-skip">Skip</button>
							<button type="submit" class="sdk-btn sdk-btn-primary sdk-btn-block messenger-prechat-submit" disabled>
								<span class="messenger-prechat-submit-text">Continue</span>
								<span class="messenger-prechat-submit-loading">
									<i class="ph ph-spinner"></i>
								</span>
							</button>
						</div>
					</form>
				</div>
			</div>
		`;

		this._attachEvents();
	}

	_renderTeamAvatars() {
		const avatars = this.state.teamAvatars;
		if (!avatars || avatars.length === 0) {
			return `
				<div class="messenger-avatar-stack">
					<div class="sdk-avatar sdk-avatar-md">S</div>
					<div class="sdk-avatar sdk-avatar-md">T</div>
				</div>
			`;
		}

		const avatarItems = avatars
			.slice(0, 3)
			.map((avatar) => {
				if (typeof avatar === 'string' && avatar.startsWith('http')) {
					return `<div class="sdk-avatar sdk-avatar-md"><img src="${avatar}" alt="Team member" /></div>`;
				}
				return `<div class="sdk-avatar sdk-avatar-md">${avatar.charAt(0).toUpperCase()}</div>`;
			})
			.join('');

		return `<div class="messenger-avatar-stack">${avatarItems}</div>`;
	}

	_escapeHtml(text) {
		if (!text) return '';
		return text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	_attachEvents() {
		const form = this.element.querySelector('form');
		const emailInput = this.element.querySelector('#messenger-prechat-email');
		const submitBtn = this.element.querySelector('.messenger-prechat-submit');
		const skipBtn = this.element.querySelector('.messenger-prechat-skip');

		const validateForm = () => {
			const email = emailInput.value.trim();
			const isEmailValid = this._isValidEmail(email);
			submitBtn.disabled = !isEmailValid;
			return isEmailValid;
		};

		emailInput.addEventListener('input', () => {
			this._clearError('messenger-email-error');
			validateForm();
		});

		emailInput.addEventListener('blur', () => {
			const email = emailInput.value.trim();
			if (email && !this._isValidEmail(email)) {
				this._showError('messenger-email-error', 'Please enter a valid email');
			}
		});

		skipBtn.addEventListener('click', () => {
			this.state.setView('chat');
		});

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			if (this._isSubmitting) return;
			if (!validateForm()) {
				this._showError('messenger-email-error', 'Please enter a valid email');
				return;
			}
			await this._handleSubmit();
		});

		validateForm();

		setTimeout(() => emailInput.focus(), 100);
	}

	_isValidEmail(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	_showError(elementId, message) {
		const errorEl = this.element.querySelector(`#${elementId}`);
		if (errorEl) {
			errorEl.textContent = message;
			errorEl.style.display = 'block';
		}
	}

	_clearError(elementId) {
		const errorEl = this.element.querySelector(`#${elementId}`);
		if (errorEl) {
			errorEl.textContent = '';
			errorEl.style.display = 'none';
		}
	}

	async _handleSubmit() {
		const nameInput = this.element.querySelector('#messenger-prechat-name');
		const emailInput = this.element.querySelector('#messenger-prechat-email');
		const submitBtn = this.element.querySelector('.messenger-prechat-submit');
		const submitText = submitBtn.querySelector(
			'.messenger-prechat-submit-text'
		);
		const submitLoading = submitBtn.querySelector(
			'.messenger-prechat-submit-loading'
		);

		const name = nameInput.value.trim();
		const email = emailInput.value.trim();

		this._isSubmitting = true;
		submitBtn.disabled = true;
		submitText.style.display = 'none';
		submitLoading.style.display = 'inline-flex';

		try {
			if (this.options.onIdentifyContact) {
				await this.options.onIdentifyContact({ name, email });
			}

			this.state.setIdentified(true, { name, email });

			this._isSubmitting = false;

			const pendingMessage = this.state.pendingMessage;
			if (pendingMessage && this.options.onStartConversation) {
				this.state.pendingMessage = null;
				this.state.setView('chat');

				await this.options.onStartConversation(
					pendingMessage.content,
					pendingMessage.attachments
				);
			} else {
				this.state.setView('chat');
			}
		} catch (error) {
			console.error('[PreChatFormView] Error submitting form:', error);
			this._showError(
				'messenger-email-error',
				'Something went wrong. Please try again.'
			);

			this._isSubmitting = false;
			submitBtn.disabled = false;
			submitText.style.display = 'inline';
			submitLoading.style.display = 'none';
		}
	}

	destroy() {
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
